// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"141":"3b90236a","980":"fe080dcd"}[chunkId] + ".css";
};